import React, { useEffect, useState } from 'react';
import logo from '../../assets/grace_information-logo-red.svg';
import {
    Box,
    Paper,
    Typography
} from "@mui/material";
import { useAlertDispatch } from '../../context/AlertContext/AlertContext';

const timeout = 5;

export default function Logout(): JSX.Element {
    const [timeRemaining, setTimeRemaining] = useState(timeout);
    const alertDispatch = useAlertDispatch();

    useEffect(() => {
        const interval = setTimeout(() => {
            if (timeRemaining > 0) {
                setTimeRemaining(timeRemaining - 1);
            } else {
                clearTimeout(interval);
                alertDispatch({ type: 'redirect', payload: '/api/user/logout' });
            }
        }, 1000);

        return () => {
            clearTimeout(interval);
        }
    }, [timeRemaining, alertDispatch])

    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            height="100vh"
        >
            <Paper sx={{
                background: 'white',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                // padding: theme.spacing(2), TODO: FIXME
                width: '400px',
            }}>
                <img src={logo} width="150px" style={{padding: '15px 0px 15px 0px'}} alt="Grace Logo" />
                <Typography component="h1" variant="h5">
                    Signing you out
                </Typography>
                <Typography variant={"subtitle1"}>
                    Wait {timeRemaining} seconds or <a href="/api/user/logout">click here</a>
                </Typography>
            </Paper>
        </Box>
    )
}
